import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Check if user has already accepted cookies
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsVisible(false);
  };

  const handleDismiss = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-deep-navy text-white p-4 shadow-lg z-50 border-t-2 border-luxury-gold">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-sm">
          <p>
            By continuing to use this site, you accept our use of cookies. 
            <a href="/privacy-policy" className="text-luxury-gold hover:underline ml-1">
              Learn more in our Privacy Policy
            </a>
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button 
            onClick={handleAccept}
            className="bg-luxury-gold text-deep-navy hover:bg-yellow-500 transition-colors duration-200"
            data-testid="button-accept-cookies"
          >
            Accept
          </Button>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={handleDismiss}
            className="text-white hover:text-luxury-gold"
            data-testid="button-dismiss-cookies"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}